import React from "react";
import Facebook from "../../Assets/UserPage/Facebook.svg";
import Instagram from "../../Assets/UserPage/Instagram.svg";

// Profile links as the app saves them (backend App\Support\SocialLinks):
// instagram, facebook, youtube, website — new values are full https URLs.
// Older rows can still hold a bare handle ("@name") or a URL without a
// scheme, so build a safe href for both and never follow anything that is
// not http(s).
const HANDLE_URL = {
  instagram: (h) => `https://instagram.com/${h}`,
  facebook: (h) => `https://facebook.com/${h}`,
  youtube: (h) => `https://youtube.com/@${h}`,
};

export const socialHref = (type, value) => {
  const raw = String(value || "").trim();
  if (!raw) return null;
  let url = raw;
  if (HANDLE_URL[type] && !raw.includes("/") && (raw.startsWith("@") || !raw.includes("."))) {
    url = HANDLE_URL[type](raw.replace(/^@/, ""));
  } else if (!/^[a-z][a-z0-9+.-]*:\/\//i.test(raw)) {
    url = `https://${raw}`;
  }
  try {
    const u = new URL(url);
    return u.protocol === "https:" || u.protocol === "http:" ? u.href : null;
  } catch {
    return null;
  }
};

const YoutubeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="#fff" aria-hidden="true">
    <path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.6 12 3.6 12 3.6s-7.5 0-9.4.5A3 3 0 0 0 .5 6.2 31 31 0 0 0 0 12a31 31 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.5 9.4.5 9.4.5s7.5 0 9.4-.5a3 3 0 0 0 2.1-2.1A31 31 0 0 0 24 12a31 31 0 0 0-.5-5.8ZM9.6 15.6V8.4l6.2 3.6-6.2 3.6Z" />
  </svg>
);

const WebsiteIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" aria-hidden="true">
    <circle cx="12" cy="12" r="10" />
    <path d="M2 12h20M12 2a15 15 0 0 1 0 20M12 2a15 15 0 0 0 0 20" />
  </svg>
);

const LINKS = [
  { type: "instagram", label: "Instagram", icon: <img src={Instagram} alt="Instagram" width="16" height="16" /> },
  { type: "facebook", label: "Facebook", icon: <img src={Facebook} alt="Facebook" width="16" height="16" /> },
  { type: "youtube", label: "YouTube", icon: <YoutubeIcon /> },
  { type: "website", label: "Website", icon: <WebsiteIcon /> },
];

/// The user's profile links (Instagram, Facebook, YouTube, website) as icon
/// links that open in a new tab; `emptyText` when there are none.
export default function SocialLinks({ profile, linkClass = "social-link", emptyText = "N/A" }) {
  const items = LINKS.map((l) => ({ ...l, href: socialHref(l.type, profile?.[l.type]) })).filter((l) => l.href);
  if (!items.length) return <span className="text-white">{emptyText}</span>;
  return items.map((l) => (
    <a
      key={l.type}
      href={l.href}
      target="_blank"
      rel="noopener noreferrer"
      className={linkClass}
      title={`${l.label}: ${l.href}`}
    >
      {l.icon}
    </a>
  ));
}
